import AdminApi from '../services/api';
import swal from 'sweetalert2';
import AutocompleteObject from '../components/Shared/AutocompleteObject';
import VueTimepicker from "vue2-timepicker";

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'schedule'],

    data() {
        return {
            title: '',
            buttonTitle: '',
            placeholderVehicle: "Vozilo",
            choosedTime: {HH: '08' , mm: '00'},
            isLoading: false,
            selectedVehicle: null,
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedVehicle = this.schedule;
                this.title = "Izmeni početak smene vozaču: " + this.schedule.courier.firstName;
                this.buttonTitle = "Izmeni ";
                if(this.schedule.startShift != null){
                    this.choosedTime.HH = this.schedule.startShift.split(":")[0]
                    this.choosedTime.mm = this.schedule.startShift.split(":")[1]
                }
            }
        },

        plate: function(val, oldVal) {
            this.hasError = '';
        },
    },
    components: { VueTimepicker },
    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeEditScheduleShift')
        },
        successEdit(){
            this.reset();
            this.$topnavbar.$emit('successEditScheduleShift')
        },

        changeShift: changeShift,
        changeTime: changeTime,
        reset: reset,
    }
}

function changeTime(event){

}

function changeShift() {
    let _self = this;
    if(_self.choosedTime.HH === "" || _self.choosedTime.mm === ""){
        this.hasError = "Molimo izaberite vreme";
        return;
    }

    let newModel = {
        startShift: _self.choosedTime.HH + ":" + _self.choosedTime.mm
    }
    _self.isLoading = true;
    AdminApiService.editStartShiftSchedule(newModel, _self.schedule.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successEdit();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}


function reset() {
    this.selectedVehicle = ''
    this.choosedTime = {HH: '08' , mm: '00'};
}


// WEBPACK FOOTER //
// ./src/modals/EditScheduleShiftModal.js